// extracted by mini-css-extract-plugin
module.exports = {"container":"TodoList_container__3qZm0"};